<button
  class="vs-button {{ disabled() ? 'disable' : 'primary' }} {{ className() }}"
  [disabled]="disabled()"
  [id]="id()"
  (click)="onClickBtn()"
  [tabindex]="className() === 'dis' ? -1 : 0"
  #input1
>
  @if (icon()) {
    <span>
      <i [class]="icon()"></i>
      {{ text() | translate }}
    </span>
  } @else {
    <span>{{ text() | translate }}</span>
  }
</button>
